import type { ComponentProps } from 'react';

import classNames from 'classnames';

import styles from './resize_handle.module.css';

export function ResizeHandle({ className, ...props }: ComponentProps<'div'>) {
  return <div {...props} className={classNames(styles.handle, className)} />;
}
